type TrackClientSource = {
    client?: AnyObj | string | null;
    project?: AnyObj | string | null;
};

/** True when the source already has an explicit client id/object. */
export function hasExplicitClient(source: { client?: AnyObj | string | null }): boolean {
    const client = source.client;
    if (typeof client === 'string')
        return !!client;
    return !!(client && typeof client === 'object' && client._id);
}

/**
 * Resolve the billing client for starting a track: explicit client first,
 * otherwise the project's sole client when populated.
 */
export function resolveTrackClient(
    source: TrackClientSource,
    projects?: AnyObj[],
): AnyObj | string | undefined {
    if (hasExplicitClient(source))
        return source.client as AnyObj | string;

    let project = source.project;
    if (typeof project === 'string' && projects?.length)
        project = projects.find((item: AnyObj) => item._id === project);

    if (!project || typeof project === 'string')
        return undefined;

    if (project.clients?.length === 1 && typeof project.clients[0] !== 'string')
        return project.clients[0];

    return undefined;
}
